var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/utils/sites.jinja"] = require( "front/utils/sites.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MembersList/MembersListAvailability.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MembersList/MembersListAvailability.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/utils/sites.jinja", false, "assets/app/front/components/MembersList/MembersListAvailability.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "SITE_AVAILABILITY")) {
var t_7 = t_4.SITE_AVAILABILITY;
} else {
cb(new Error("cannot import 'SITE_AVAILABILITY'")); return;
}
context.setVariable("SITE_AVAILABILITY", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_9 = "";t_9 += "\n    <div class=\"MembersListAvailability\"  data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n        <h2>Availability List</h2>\n        <div class=\"MembersListAvailability-text\">Members of the Art Directors Craft, the Illustrators and Matte Artists Craft, the Set Designers Craft, and the Scenic, Title & Graphic Artists Craft who are currently available for work can be found by downloading the Availability List per craft. If you have any questions, please contact the ADG Office at <a href=\"tel:818-762-9995\">(818) 762-9995</a></div>\n        <a class=\"MembersListAvailability-button\" href=\"";
t_9 += runtime.suppressValue((lineno = 8, colno = 67, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "domain_url"), "domain_url", context, [runtime.contextOrFrameLookup(context, frame, "SITE_AVAILABILITY"),"index"])), env.opts.autoescape);
t_9 += "\">Browse Availability List</a>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("MembersListAvailability");
context.setVariable("MembersListAvailability", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MembersList/MembersListAvailability.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MembersList/MembersListAvailability.jinja
// module id = 124
// module chunks = 0